import { QueryClient } from '@tanstack/react-query';

// Next.js App Router–safe QueryClient accessor.
//
// On the server: a new QueryClient per SSR render, so requests can't leak
// cached data into each other. The curi.live student app's <GameButler>
// is ssr:false today, but this pattern keeps us safe if anything in the
// tree ever runs a query during SSR.
//
// On the client: a module-level singleton shared by React and non-React
// code (notably the responseSync worker, which needs to read drafts and
// observed responses from outside the React tree so submissions survive
// component unmount).
//
// The /dev page keeps its own local QueryClient with staleTime: Infinity
// for fixture stability and does not wire through this.

const isServer = typeof window === 'undefined';

function makeQueryClient(): QueryClient {
  return new QueryClient();
}

let browserQueryClient: QueryClient | undefined;

export function getQueryClient(): QueryClient {
  if (isServer) {
    return makeQueryClient();
  }
  if (!browserQueryClient) {
    browserQueryClient = makeQueryClient();
  }
  return browserQueryClient;
}
